import { Component, OnInit, Input, DoCheck, Optional, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, FormGroupDirective, ControlContainer } from '@angular/forms';
import { DatePickerOptions } from '../../Shared/Models/datePickerOptions';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { UtilityService } from '../../Shared/services/UtilityService';
import { PickerType } from '../../Shared/Enums/PickerType';
import { StartView } from '../../Shared/Enums/StartView';
import { SelectMode } from '../../Shared/Enums/SelectMode';
import { OnPagingFiltersChangeService } from '../../Shared/services/OnPagingFiltersChange.service';
import { formatDate } from '@fullcalendar/core';

@Component({
  selector: 'BBSF-DateTimePicker',
  templateUrl: './DateTimePicker.component.html',
  styleUrls: ['./DateTimePicker.component.scss']
})
export class DateInputComponent implements OnInit {
  static controlContainerstatic = null;
  // tslint:disable-next-line: max-line-length
  constructor(private onChangeService: OnPagingFiltersChangeService, private ErrorHandler: ErrorMassageValidation, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public DateInputControlHost: FormGroupDirective) {
    DateInputComponent.controlContainerstatic = this.controlContainer;
  }
  @Input() group: FormGroup;
  @Input() options: DatePickerOptions;
  DatePickerFormControl: AbstractControl;
  @Output() OnChange = new EventEmitter();
  markAllAsTouched: boolean = false;
  validationRules = [];
  validationRulesasync = [];

  ngOnInit() {
    UtilityService.isCreatedBefor = false
    this.group.addControl(this.options.Name, new FormControl(''));
    this.DatePickerFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);

    this.DatePickerFormControl.setValue(this.options.Value);

    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }

    }


    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }
    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);

    this.DatePickerFormControl.setValidators(this.validationRules);
    this.DatePickerFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.DatePickerFormControl.disable();
    }
    this.DateInputControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })



  }


  ngAfterViewInit(): void {
    this.controlUtility.setAttributeForControl(this.options)
  }


  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }
    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }




  copyInputMessage(inputElement) {
    this.controlUtility.CopyInputMessage(inputElement)
  }



  getSelectMode(type: number) {
    let Value = (SelectMode[type] as string)
    return Value.toLowerCase()
  }
  getPickerType(type: number) {
    let Value = (PickerType[type] as string)
    return Value.toLowerCase()
  }
  getStartView(type: number) {
    if (type == 3)
      return "multi-year";
    else {
      let Value = StartView[type] as string
      return Value.toLowerCase()
    }
  }


  onDateSelect(item) {
    let DateValue;
    if (this.options.SelectMode == 2) {
      for (let index = 0; index < item.value.length; index++) {
        item.value[index] = new Date(item.value[index]).toISOString();

      }
      DateValue = item.value;
    }
    else {
      DateValue = new Date(item.value).toISOString();

    }
    this.DatePickerFormControl.setValue(DateValue)
    this.onChangeService.ChangeValue(this.options.Name);
    this.OnChange.emit(DateValue);


  }

  //External Method
  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.DatePickerFormControl, this.validationRules, this.options)
  }
  //External Method
  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.DatePickerFormControl, this.validationRules, this.options)
  }

  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.DatePickerFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.DatePickerFormControl, this.validationRules, CustomValidation)
  }

  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.DatePickerFormControl)
  }

}



